import { useURLState } from "lib/hooks/useURLState";
import { SortState, SortStateSchema } from "lib/search/types";
import { isDefined } from "lib/utils";
import { SearchOrganisationsParams } from "../../lib/hooks/api/organisations/useOrganisations";
import {
  AnchorOrganisationType,
  OrgSortBy,
  OrgSortOrder,
  SearchOrgRole,
} from "../../lib/types/graphQLEnums";
import { BuyerTableFilters } from "./utils/types";

export const DEFAULT_BUYER_FILTERS: BuyerTableFilters = {
  supplierSme: "",
};
export const DEFAULT_BUYER_SORT: SortState = { field: "noticeCount", order: "DESC" };

function parseUrlFilterState(
  val?: BuyerTableFilters,
  defaultFilters?: BuyerTableFilters,
): BuyerTableFilters {
  if (typeof val !== "object" || val === null) {
    return defaultFilters || DEFAULT_BUYER_FILTERS;
  }

  const filters = val as BuyerTableFilters;

  return {
    ...filters,
    supplierGuids: filters.supplierGuids?.filter(isDefined),
  };
}

export function useFilterableBuyerTableState(
  defaultFilters: BuyerTableFilters,
  defaultSort: SortState,
) {
  const [buyerTableFilters, setBuyerTableFilters] = useURLState(
    "buyerFilters",
    defaultFilters,
    (val) => parseUrlFilterState(val as BuyerTableFilters, defaultFilters),
  );

  const [buyerSort, setBuyerSort] = useURLState("sortState", defaultSort, SortStateSchema);

  return {
    buyerTableFilters: buyerTableFilters,
    setBuyerTableFilters,
    buyerSort: buyerSort,
    setBuyerSort,
  };
}

export function convertBuyerFiltersToOrgFilters(
  filters: BuyerTableFilters,
  sortState: SortState,
  pageSize: number,
  currentPage: number,
): SearchOrganisationsParams {
  return {
    limit: pageSize,
    page: currentPage,
    role: SearchOrgRole.Buyer,
    ids: filters.buyerGuids,
    listIds: filters.buyerLists && filters.buyerLists.length > 0 ? filters.buyerLists : undefined,
    pubSecOrgTypes: filters.buyerTypes,
    regionIds: filters.hqCountry?.regions,
    countryCodes: filters.hqCountry?.countries,
    names: filters.buyerName ? [filters.buyerName] : undefined,
    sortOrder: sortState.order as OrgSortOrder,
    sortBy: sortState.field as OrgSortBy,
    anchorOrganisation:
      filters.supplierGuids?.length === 1
        ? {
            organisationId: filters.supplierGuids[0],
            type: AnchorOrganisationType.Supplier,
          }
        : undefined,
  };
}
